import { useCurrentOrders } from "../../hooks/useOrdersHook";
import { useMainContext } from "../../contexts/main";
import ModalLayout from "../../layouts/ModalLayout";
import OrdersDeleteModal from "../../modals/OrdersDeleteModal";
import RTableLayout from "./RTableLayout";
import { Row, HistoryResponsiveRow } from "../../styles/table";
import { DText, Flex } from "../../styles/MarketStyles";
import { SOCKET_URL } from "../../constants/urls";
import { CancelOrderBtn, TextWithMargin } from "../../styles/OrdersStyle";
import Text from "../../utils/Text";
import { formatDate, formatNumber } from "../../utils/common";
import { getMainTheme } from "../../utils/theme";


const RCurrentOrders = ({ data }) => {

    const { main: { lang, theme } } = useMainContext()

    const {
        deleteModal,
        setDeleteModal,
        onCloseDeleteModal,
        onModalClicked
    } = useCurrentOrders()

    const { data: orders } = data
    return (
        <>
            <RTableLayout
                data={data}
            >
                {orders?.data?.map((item, idx) => {

                    let percent = 0
                    if (item.tradedAmount) {
                        percent = (item.tradedAmount / (item.amount + item.tradedAmount)) * 100
                    }

                    return (
                        <Row
                            cs={'100%'}
                            index={idx}
                            percent={percent}
                            type={item.type}
                            currentOrder
                            noHover
                        >
                            <Flex fw justify={'space-between'} style={{ direction: 'ltr' }}>
                                <Flex>
                                    <img
                                        style={{ marginRight: '-10px', zIndex: 10 }}
                                        src={SOCKET_URL + `assets/icon/${item.coin}.png`}
                                        alt={' '}
                                        width={20}
                                        height={20}
                                    />
                                    {item.pair === 'irt' ?
                                        <img
                                            src={require('../../assets/images/tooman.png')}
                                            alt={' '}
                                            width={20}
                                            height={20}
                                        />
                                        :
                                        <img
                                            src={SOCKET_URL + `assets/icon/${item.pair}.png`}
                                            alt={' '}
                                            width={20}
                                            height={20}
                                        />
                                    }
                                    <DText primary fontSize={'m'} style={{ margin: '0 5px' }}>
                                        {`${item.coin?.toUpperCase()}/${item.pair?.toUpperCase()}`}
                                    </DText>
                                    <TextWithMargin style={{ margin: '0 5px', fontSize: '0.8rem', color: item.type === 'sell' ? "#e9106c" : "#1ce087" }}>
                                        {`${item.type === 'buy' ? 'Buy' : 'Sell'}/${item.submit}`}
                                    </TextWithMargin>
                                </Flex>
                                <CancelOrderBtn onClick={() => {
                                    setDeleteModal({
                                        open: true,
                                        id: item._id
                                    })
                                }}>
                                    <Flex>
                                        <Text tid={'cancel-order'} />
                                    </Flex>
                                </CancelOrderBtn>
                            </Flex>
                            <HistoryResponsiveRow>
                                <DText main fontSize={'s'}>
                                    <Text tid={'amount'} />
                                </DText>
                                <DText primary fontSize={'s'}>
                                    {formatNumber(item.amount)}
                                </DText>
                            </HistoryResponsiveRow>
                            <HistoryResponsiveRow>
                                <DText main fontSize={'s'}>
                                    <Text tid={'price'} />
                                </DText>
                                <DText primary fontSize={'s'}>
                                    {formatNumber(item.price)}
                                </DText>
                            </HistoryResponsiveRow>
                            <HistoryResponsiveRow>
                                <DText main fontSize={'s'}>
                                    <Text tid={'priceUnit'} />
                                </DText>
                                <DText primary fontSize={'s'}>
                                    {formatNumber(item.priceUnit)}
                                </DText>
                            </HistoryResponsiveRow>
                            <HistoryResponsiveRow>
                                <DText main fontSize={'s'}>
                                    <Text tid={'traded-pc'} />
                                </DText>
                                <DText primary fontSize={'s'}>
                                    {`% ${percent.toFixed(2)}`}
                                </DText>
                            </HistoryResponsiveRow>
                            <HistoryResponsiveRow>
                                <DText main fontSize={'s'}>
                                    <Text tid={'date'} />
                                </DText>
                                <DText primary fontSize={'s'}>
                                    {`${formatDate(item.createdAt, "time", lang === "en" ? "en-US" : "fa-IR")}
                                    - ${formatDate(item.createdAt, "date", lang === "en" ? "en-US" : "fa-IR")}`}
                                </DText>
                            </HistoryResponsiveRow>
                        </Row>
                    )
                })}

            </RTableLayout>
            <ModalLayout
                width="400px"
                open={deleteModal.open}
                onClose={onCloseDeleteModal}
            >
                <OrdersDeleteModal onModalBtnClicked={onModalClicked} />
            </ModalLayout>
        </>
    )
}

export default RCurrentOrders;
